export default "__VITE_ASSET__8a4483f0__"